import ConcreteFoundationFloor from './assemblies/ConcreteFoundationFloor';
import FloorsOverUnheatedSpaces from './assemblies/FloorsOverUnheatedSpaces';
import RoofsBelowAttics from './assemblies/RoofsBelowAttics';
import RoofsCathedralCeilings from './assemblies/RoofsCathedralCeilings';
import WallsAboveGrade from './assemblies/WallsAboveGrade/index';
import WallsBelowGrade from './assemblies/WallsBelowGrade';

export const CALC_COMPONENTS = {
  wallsAboveGrade: WallsAboveGrade,
  roofsBelowAttics: RoofsBelowAttics,
  roofsCathedral: RoofsCathedralCeilings,
  wallsBelowGrade: WallsBelowGrade,
  floorsOverUnheated: FloorsOverUnheatedSpaces,
  concreteFoundationFloor: ConcreteFoundationFloor,
};

export const ASSEMBLIES = {
  roofsBelowAttics: 'roofs_below_attics', // 'Roofs/ceilings below attics'
  roofsCathedral: 'roofs_cathedral', // 'Roofs/cathedral ceilings'
  wallsAboveGrade: 'walls_above_grade', // 'Walls above grade not in contact with the ground'
  wallsBelowGrade: 'walls_below_grade', // 'Foundation walls below grade and in contact with the ground',
  floorsOverUnheated: 'floors_over_unheated', // 'Floors over unheated spaces',
  concreteFoundationFloor: 'concrete_foundation_floor', // 'Concrete foundation floor slab',
};

export const GROUPS = [
  {
    id: 'roofs',
    label: 'Roofs/Ceilings',
    items: [
      { id: 'roofsBelowAttics', label: 'Roofs/ceilings below attics' },
      { id: 'roofsCathedral', label: 'Roofs/cathedral ceilings' },
    ],
  },
  {
    id: 'walls',
    label: 'Walls',
    items: [
      { id: 'wallsBelowGrade', label: 'Foundation walls below grade and in contact with the ground' },
      { id: 'wallsAboveGrade', label: 'Walls above grade not in contact with ground' },
    ],
  },
  {
    id: 'floors',
    label: 'Floors/Foundations',
    items: [
      { id: 'floorsOverUnheated', label: 'Floors over unheated spaces' },
      { id: 'concreteFoundationFloor', label: 'Concrete foundation floor slab' },
    ],
  },
  {
    id: 'summary',
    label: 'Results Summary',
    items: [],
  },
];
